function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { styleguide, colorVar } from "../../styleguide";
import TextBody from "../textComponents/TextBody/TextBody";
import TextCallout2 from "../textComponents/TextCallout2";
import { IconCheck, IconHeadsUp } from "../Icon";
var inputStatus = {
  ERROR: 'error',
  SUCCESS: 'success'
};
var fontSize = '17px';
var Wrapper = styled(TextBody).withConfig({
  displayName: "TextArea__Wrapper",
  componentId: "sc-1kbuikv-0"
})(["display:flex;flex-direction:column;flex-grow:1;"]);
var LabelWrapper = styled.div.withConfig({
  displayName: "TextArea__LabelWrapper",
  componentId: "sc-1kbuikv-1"
})(["margin-bottom:8px;display:flex;flex-direction:row;justify-content:space-between;align-items:center;flex-shrink:0;"]);
var Label = styled.label.withConfig({
  displayName: "TextArea__Label",
  componentId: "sc-1kbuikv-2"
})(["font-family:", ";font-size:", ";line-height:", ";"], styleguide.font.family.medium, fontSize, fontSize);
var SubLabel = styled(TextCallout2).withConfig({
  displayName: "TextArea__SubLabel",
  componentId: "sc-1kbuikv-3"
})(["font-size:", ";line-height:", ";text-align:right;"], fontSize, fontSize);
var TextAreaWrapper = styled.div.withConfig({
  displayName: "TextArea__TextAreaWrapper",
  componentId: "sc-1kbuikv-4"
})(["position:relative;flex-grow:1;display:flex;"]);
var Textarea = styled.textarea.withConfig({
  displayName: "TextArea__Textarea",
  componentId: "sc-1kbuikv-5"
})(["font-family:", ";font-size:", ";flex-grow:1;min-height:60px;resize:vertical;outline:none;line-height:26px;padding:15px;border-width:1px;border-style:solid;border-color:", ";box-sizing:border-box;border-radius:6px;width:100%;appearance:none;background-color:", ";padding-right:", ";opacity:", ";&:focus{border-color:", ";}::placeholder{color:var(--bui-text-placeholder);opacity:1;}text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;"], styleguide.font.family.regular, fontSize, function (_ref) {
  var status = _ref.status;
  return status === inputStatus.SUCCESS && colorVar('--bui-form-border-success') || status === inputStatus.ERROR && colorVar('--bui-form-border-error') || colorVar('--bui-form-border');
}, function (_ref2) {
  var status = _ref2.status;
  return status === inputStatus.ERROR && colorVar('--bui-background-error') || colorVar('--bui-background');
}, function (_ref3) {
  var status = _ref3.status;
  return status && '50px';
}, function (_ref4) {
  var readonly = _ref4.readonly;
  return readonly ? '0.5' : '1';
}, colorVar('--bui-form-border-focus'));
var IconContainer = styled.div.withConfig({
  displayName: "TextArea__IconContainer",
  componentId: "sc-1kbuikv-6"
})(["position:absolute;background:none;right:16px;top:16px;"]);
var ErrorLabel = styled(TextCallout2).withConfig({
  displayName: "TextArea__ErrorLabel",
  componentId: "sc-1kbuikv-7"
})(["display:block;margin-top:5px;color:", ";font-size:", ";"], colorVar('--bui-text-error'), fontSize);
var MaxLength = styled.span.withConfig({
  displayName: "TextArea__MaxLength",
  componentId: "sc-1kbuikv-8"
})(["font-size:12px;line-height:20px;display:flex;justify-content:flex-end;color:", ";margin-left:auto;&.error{color:", ";}"], colorVar('--bui-text-placeholder'), colorVar('--bui-text-error'));
var FieldInfo = styled.div.withConfig({
  displayName: "TextArea__FieldInfo",
  componentId: "sc-1kbuikv-9"
})(["display:flex;align-items:center;"]);

var SuccessIcon = function SuccessIcon() {
  return /*#__PURE__*/React.createElement(IconCheck, {
    width: 24,
    height: 24,
    color: colorVar('--bui-text-success')
  });
};

var ErrorIcon = function ErrorIcon() {
  return /*#__PURE__*/React.createElement(IconHeadsUp, {
    width: 24,
    height: 24,
    color: colorVar('--bui-text-error')
  });
};

export var TextArea = function TextArea(_ref5) {
  var label = _ref5.label,
      subLabel = _ref5.subLabel,
      placeholder = _ref5.placeholder,
      name = _ref5.name,
      value = _ref5.value,
      onChange = _ref5.onChange,
      onBlur = _ref5.onBlur,
      onFocus = _ref5.onFocus,
      status = _ref5.status,
      errorText = _ref5.errorText,
      _ref5$readonly = _ref5.readonly,
      readonly = _ref5$readonly === void 0 ? false : _ref5$readonly,
      className = _ref5.className,
      rows = _ref5.rows,
      maxLength = _ref5.maxLength,
      _ref5$showMaxLength = _ref5.showMaxLength,
      showMaxLength = _ref5$showMaxLength === void 0 ? true : _ref5$showMaxLength;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      fieldLength = _useState2[0],
      setFieldLength = _useState2[1];

  useEffect(function () {
    if (value) {
      setFieldLength(value.length);
    }
  }, [value]);

  var countCharacters = function countCharacters(e) {
    setFieldLength(e.target.value.length);
  };

  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className
  }, (label || subLabel) && /*#__PURE__*/React.createElement(LabelWrapper, null, label && /*#__PURE__*/React.createElement(Label, {
    htmlFor: name
  }, label), subLabel && /*#__PURE__*/React.createElement(SubLabel, {
    htmlFor: name,
    tagName: "label"
  }, subLabel)), /*#__PURE__*/React.createElement(TextAreaWrapper, null, /*#__PURE__*/React.createElement(Textarea, {
    id: name,
    "data-cy": name,
    name: name,
    value: value,
    placeholder: placeholder,
    onInput: function onInput(ev) {
      return countCharacters(ev);
    },
    onChange: onChange && onChange,
    onFocus: onFocus && onFocus,
    onBlur: onBlur && onBlur,
    readOnly: readonly,
    status: status,
    rows: rows
  }), status && /*#__PURE__*/React.createElement(IconContainer, null, status === inputStatus.SUCCESS && /*#__PURE__*/React.createElement(SuccessIcon, null), status === inputStatus.ERROR && /*#__PURE__*/React.createElement(ErrorIcon, null))), /*#__PURE__*/React.createElement(FieldInfo, null, status === inputStatus.ERROR && /*#__PURE__*/React.createElement(ErrorLabel, {
    tagName: "label",
    htmlFor: name
  }, errorText), showMaxLength && maxLength && /*#__PURE__*/React.createElement(MaxLength, {
    className: status === inputStatus.ERROR ? 'error' : ''
  }, fieldLength, "/", maxLength, " tecken")));
};
TextArea.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A non-human-readable name for id/name-attribute etc.
   */
  name: PropTypes.string.isRequired,

  /**
   * A descriptive human-readable label
   */
  label: PropTypes.string,

  /**
   * A placeholder text that will be shown in the text area when no value is present
   */
  placeholder: PropTypes.string,

  /**
   * A complementary label to the text area filed. e.g. max 8 letters
   */
  subLabel: PropTypes.string,

  /**
   * The value attribute of the text area
   */
  value: PropTypes.string,

  /**
   * Callback method for when text area is changing
   */
  onChange: PropTypes.func,

  /**
   * Callback method for when text area is focused
   */
  onFocus: PropTypes.func,

  /**
   * Callback method for when text area is blurred
   */
  onBlur: PropTypes.func,

  /**
   * Enable/disable the text area
   */
  readonly: PropTypes.bool,

  /**
   * A validation error message
   */
  errorText: PropTypes.string,

  /**
   * Show success or error style on the input field
   */
  status: PropTypes.oneOf(['success', 'error']),

  /**
   * Optional class name
   */
  className: PropTypes.string,

  /**
   * Optionally set initial height of textarea. Browser default (2) if not set.
   */
  rows: PropTypes.number,

  /**
   * Max length of textarea value.
   */
  maxLength: PropTypes.number,
  showMaxLength: PropTypes.bool
} : {};
export default TextArea;
//# sourceMappingURL=TextArea.js.map